var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMachineLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.26,6.86l-3.39-2a.75.75,0,1,1,.78-1.28l3.36,2Z",
    style: {
      fill: "#aecbfa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52,10.31,4.69,6.36a.75.75,0,0,1,.75-1.3l6.08,3.52Z",
    style: {
      fill: "#aecbfa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,5.33a.76.76,0,0,0-1-.27L12.75,8.4V6.85l3.39-2a.74.74,0,0,0,.25-1,.75.75,0,0,0-1-.25L11.65,5.78a.79.79,0,0,0-.39.68V21a.75.75,0,1,0,1.49,0V10.14l6.57-3.78A.76.76,0,0,0,19.6,5.33Z",
    style: {
      fill: "#669df6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.01,
    cy: 3.09,
    r: 0.84,
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48,10.82a.73.73,0,0,1,.38.64v4.08a.74.74,0,0,1-.38.65.79.79,0,0,1-.37.1.86.86,0,0,1-.38-.1L4.41,13.7a.75.75,0,1,1,.75-1.3l3.2,1.84V11.9l-1.45-.83a.75.75,0,0,1-.27-1,.74.74,0,0,1,1-.27Z",
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.26,
    cy: 9.26,
    r: 0.84,
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.34,9.77a.74.74,0,0,1,1,.27.75.75,0,0,1-.27,1l-1.45.83v2.34l3.2-1.84a.75.75,0,1,1,.75,1.3l-4.32,2.49a.86.86,0,0,1-.38.1.79.79,0,0,1-.37-.1.74.74,0,0,1-.38-.65V11.46a.73.73,0,0,1,.38-.64Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 9.26,
    r: 0.84,
    style: {
      fill: "#4285f4"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineLearning);
export default __webpack_public_path__ + "static/media/Machine Learning.efa7e69dacac27b3bbd6b288709b242b.svg";
export { ForwardRef as ReactComponent };